module.exports = (s) => {
  return [
    {
      name: 'ID',
      value: 'id',
    },
    {
      name: '规则名称',
      value: 'rule_name',
    },
    {
      name: '触发条件',
      width: 300,
      format: ({ rule_list }) => {
        const h = s.$createElement;
        return rule_list?.length ? h('div', null, rule_list.map(({ cost, condition_type, condition_value }) => {
          return h('div', null, `消耗大于等于${cost}元，且${s.condition_type_map[condition_type]}小于${condition_value}个`);
        })) : '-';
      },
    },
    {
      name: '状态',
      format: ({ status }) => {
        const status_map = {
          1: '启用',
          2: '停用',
        };
        return status_map[status];
      },
    },
    {
      name: '操作人',
      value: 'operator',
    },
    {
      name: '创建时间',
      value: 'created_at',
    },
    {
      name: '最近一次修改时间',
      value: 'updated_at',
    },
    {
      name: '操作',
      width: 120,
      format: (row) => {
        const { status } = row;
        const h = s.$createElement;
        const ele = h('div',
          null, [
            h('el-link',
              {
                props: {
                  type: 'primary',
                  underline: false,
                },
                on: {
                  click: () => {
                    s.onEdit(row);
                  },
                },
              },
              '编辑'
            ),
            h('el-link',
              {
                class: 'ml-10',
                props: {
                  type: status === 1 ? 'success' : 'danger',
                  underline: false,
                },
                on: {
                  click: () => {
                    s.onSwitch(row);
                  },
                },
              },
              status === 1 ? '停用' : '启用',
            ),
            h('el-link',
              {
                class: 'ml-10',
                props: {
                  type: 'info',
                  underline: false,
                },
                on: {
                  click: () => {
                    s.onDel(row);
                  },
                },
              },
              '删除'
            ),
          ]
        );
        return ele;
      },
    },
  ];
};
